import React from 'react';

import { Typography } from '@material-ui/core';
import { RadioField, Step } from '../SteppedForm';

const StepCabsureCoverType = (props) => {
  return (
    <Step
      id="cabsure_cover_type"
      title="Cabsure Cover type"
      skip={() => !props.getVehicle().requested_cabsure_insurance_quote || !props.inStates('nsw')}>
      <Typography variant="body1" paragraph>
        Choose the type of cover you are interested in receiving a quote
      </Typography>
      <br />
      <RadioField id="cabsurecovertype" required options={props.cabsureCoverOptions} />
    </Step>
  );
};

export default StepCabsureCoverType;
